import React from "react";
import { Button, Box, Card, Typography } from "@mui/material";
import BaseModal from "./BaseModal";
import FormField from "../forms/FormField";
import { StyledLink } from "../CustomizerCart";
import getDataVolume from "../../utils/getDataVolume";
import BaseDrawer from "./mobile/BaseDrawer";

const initialState = {
  values: {
    name: "",
  },
  valid: false,
  loading: false,
  error: {
    message: "",
    data: null,
  },
};

const SaveDesignModal = ({ onClose, handleSaveDesign, isMobile }) => {
  const [form, setForm] = React.useState(initialState);

  const Modal = isMobile ? BaseDrawer : BaseModal;

  React.useEffect(() => {
    if (form.values.name) {
      setForm((state) => ({
        ...state,
        valid: true,
      }));
    } else {
      setForm((state) => ({
        ...state,
        valid: false,
      }));
    }
  }, [form.values]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((state) => ({
      ...state,
      values: {
        ...state.values,
        [name]: value,
      },
    }));
  };

  const handleClose = React.useCallback(() => {
    setForm(initialState);
    onClose();
  }, []);

  const handleSave = () => {
    const res = handleSaveDesign(form.values.name);
    res ? setForm((prevState) => ({ ...prevState, error: res })) : handleClose();
  };

  const handleOk = () => {
    handleSaveDesign(form.values.name, form.error.data.designs);
    handleClose();
  };

  const handleDeleteItem = (id) => {
    setForm((prevState) => {
      const designs = { ...prevState.error.data.designs };
      const { size: currentDeleteVolume } = getDataVolume(designs[id]);

      delete designs[id];

      return {
        ...prevState,
        error: {
          ...prevState.error,
          data: {
            ...prevState.error.data,
            designs,
            sum: prevState.error.data.sum + currentDeleteVolume,
            flag: prevState.error.data.sum + currentDeleteVolume >= prevState.error.data.size,
          },
        },
      };
    });
  };

  return (
    <Modal headline="Save Your Design" onClose={handleClose}>
      <FormField
        readOnly={Boolean(form.error.data)}
        label="Project Name"
        name="name"
        handleChange={handleChange}
      />
      {form.error.message && (
        <Card
          elevation={0}
          sx={{
            background:
              "linear-gradient(90deg, rgba(204,48,69,1) 0%, rgba(234,96,165,1) 20%, rgba(245,225,124,1) 40%, rgba(79,173,91,1) 60%, rgba(50,152,196,1) 80%, rgba(175,145,189,1) 100%)",
            borderRadius: "12px",
            padding: "2px",
          }}
        >
          <Card
            elevation={0}
            sx={{
              borderRadius: "6px",
              margin: "6px",
              padding: "12px",
            }}
          >
            {form.error.message}
            <>
              <Box mt={2} sx={{ display: "flex", alignItems: "center" }}>
                <Typography px={1} sx={{ textDecoration: "underLine" }}>
                  Project name:
                </Typography>
              </Box>
              {Object.entries(form.error?.data?.designs)?.map(([id, design], index) => {
                return (
                  <Box sx={{ display: "flex", alignItems: "center" }} key={id}>
                    <Typography px={1} sx={{ minWidth: "80%" }} variant="button">
                      {design.name}
                    </Typography>

                    {form.error?.data?.designId ? (
                      form.error?.data?.designId !== id && (
                        <StyledLink
                          px={1}
                          m={0}
                          sx={{ minWidth: "20%", marginRight: "0px !important" }}
                          onClick={() => handleDeleteItem(id)}
                        >
                          Delete
                        </StyledLink>
                      )
                    ) : index + 1 !== Object.entries(form.error?.data?.designs)?.length ? (
                      <StyledLink
                        px={1}
                        sx={{ minWidth: "20%", marginRight: "0px !important" }}
                        onClick={() => handleDeleteItem(id)}
                      >
                        Delete
                      </StyledLink>
                    ) : null}
                  </Box>
                );
              })}
            </>
          </Card>
        </Card>
      )}

      {!form.error.message ? (
        <Box
          my={2}
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            sx={{
              width: "100%",
              maxWidth: "280px",
            }}
            disabled={form.loading || !form.valid}
            onClick={handleSave}
          >
            {form.loading ? "Saving..." : "Save"}
          </Button>
        </Box>
      ) : (
        <Box
          my={2}
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            disabled={!form.error.data.flag}
            onClick={handleOk}
            sx={{ marginRight: "10px" }}
            variant="contained"
          >
            Ok
          </Button>
        </Box>
      )}
    </Modal>
  );
};

export default SaveDesignModal;
